import styled from '@emotion/styled';
import UnstyledButton from '@embed/components/common/UnstyledButton';
export const FlexColumn = styled.div `
  display: flex;
  flex-direction: column;
`;
export const VideoCaption = styled.div `
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  margin-left: 50px;
  margin-right: 50px;
`;
export const MainMenuContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const ToggleSubtitleButton = styled(UnstyledButton) `
  display: flex !important;
  align-items: center;
  justify-content: center;
`;
